import * as React from "react";
import { isSameDay } from "date-fns";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import {
	DropTarget,
	DropTargetConnector,
	DropTargetMonitor,
	ConnectDropTarget
} from "react-dnd";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { InjectedTranslateProps, translate } from "react-i18next";
import { Table } from "../../api/tables";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import { Reservation } from "../../api/reservations";
import { ConnectedReservationItem } from "./reservation-item";
import { notEmpty } from "../../util/general-utility";
import { DropTargetData } from "./day-overview";
import { ConnectedTiteledPaper } from "../layout/titeled-paper";

interface State {}

export interface ReservationListProps {}

interface ConnectedReservationListProps extends WithStyles<typeof styles> {
	tables: Table[];
	reservations: Reservation[];
	selectedDate: Date;
	canDrop?: boolean;
	isOver?: boolean;
	connectDropTarget?: ConnectDropTarget;
}

type Props = ReservationListProps &
	ConnectedReservationListProps &
	InjectedTranslateProps;

export class ReservationList extends React.Component<Props, State> {
	public state: State = {};

	render() {
		const {
			classes,
			reservations,
			connectDropTarget,
			selectedDate
		} = this.props;

		const openReservations = reservations.filter(
			r => !notEmpty(r.tableId) && isSameDay(r.date, selectedDate)
		);

		return (
			connectDropTarget &&
			connectDropTarget(
				<div className={classes.root}>
					<ConnectedTiteledPaper title="Nicht zugeordnete Reservierungen">
						{openReservations.length > 0 ? (
							openReservations.map(r => (
								<ConnectedReservationItem key={r.id} {...r} />
							))
						) : (
							<Typography className={classes.note}>
								Keine Reservierungen vorhanden!
							</Typography>
						)}
					</ConnectedTiteledPaper>
				</div>
			)
		);
	}
}

@DropTarget(
	"ReservationItem",
	{
		drop(): DropTargetData {
			return { tableId: null };
		}
	},
	(connect: DropTargetConnector, monitor: DropTargetMonitor) => ({
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
		canDrop: monitor.canDrop()
	})
)
class DecoratedReservationList extends ReservationList {}

const mapStateToProps = (state: StoreState) => ({
	tables: state.tables,
	reservations: state.reservations,
	selectedDate: state.date
});

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		paper: {
			padding: 20
		},
		title: {
			marginBottom: 10
		},
		note: {
			fontStyle: "italic"
		}
	});

export const ConnectedReservationList = translate("translations")(
	withStyles(styles)(connect(mapStateToProps)(DecoratedReservationList))
);
